
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contract/id_password",
      function () {
        return require("private-next-pages/contract/id_password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contract/id_password"])
      });
    }
  